import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { subirBoletas } from "../../../actions/boletasActions";
import { avisoError } from "../../components/AvisosMensajes/MensajesSwalf";
import DropZoneV2 from "../../components/plugins/DropzoneV2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUpload, faCalendarAlt, faFileAlt, faTimesCircle,
  faCheckCircle, faExclamationTriangle, faInfoCircle
} from "@fortawesome/free-solid-svg-icons";
import { Alert } from "react-bootstrap";

const MESES = [
  { id: 1,  value: "Enero" },   { id: 2,  value: "Febrero" },
  { id: 3,  value: "Marzo" },   { id: 4,  value: "Abril" },
  { id: 5,  value: "Mayo" },    { id: 6,  value: "Junio" },
  { id: 7,  value: "Julio" },   { id: 8,  value: "Agosto" },
  { id: 9,  value: "Septiembre" }, { id: 10, value: "Octubre" },
  { id: 11, value: "Noviembre" },  { id: 12, value: "Diciembre" },
];

const ANIOS = ["2024", "2025", "2026", "2027"];

const FormularioSubidaBoletas = () => {
  const now = new Date();
  const { usuario } = useSelector(state => state.usuario);
  const dispatch = useDispatch();

  const [periodo, setPeriodo] = useState(now.getFullYear().toString());
  const [mes, setMes]         = useState(String(now.getMonth() + 1));
  const [archivos, setArchivos] = useState([]);
  const [isValidNombre, setIsValidNombre] = useState(true);

  const removeArchivo = (name) => setArchivos(prev => prev.filter(a => a.name !== name));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (archivos.length === 0) { avisoError("Debe cargar al menos un documento."); return; }
    dispatch(subirBoletas({ periodo, mes }, archivos, usuario));
  };

  const mesLabel = MESES.find(m => String(m.id) === mes)?.value || "";

  return (
    <form onSubmit={handleSubmit} className="px-2 py-1">

      {/* Info formato */}
      <Alert variant="info" style={{ fontSize: 13, borderRadius: 8, marginBottom: 16 }}>
        <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
        El nombre de cada PDF debe seguir el formato: <strong>DNI_EMPLEADO_EMPRESA.pdf</strong><br />
        Ejemplo: <code>12345678_Juan Pérez_INEDI.pdf</code>
      </Alert>

      {/* Periodo y Mes */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontSize: 13, fontWeight: 600, color: "#555", marginBottom: 4 }}>
            <FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" />Periodo (Año)
          </label>
          <select
            className="form-control form-control-sm"
            value={periodo}
            onChange={e => setPeriodo(e.target.value)}
            required
          >
            <option value="">Seleccione un periodo</option>
            {ANIOS.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div className="col-md-6">
          <label style={{ fontSize: 13, fontWeight: 600, color: "#555", marginBottom: 4 }}>
            <FontAwesomeIcon icon={faCalendarAlt} className="mr-1 text-muted" />Mes
          </label>
          <select
            className="form-control form-control-sm"
            value={mes}
            onChange={e => setMes(e.target.value)}
            required
          >
            <option value="">Seleccione un mes</option>
            {MESES.map(m => <option key={m.id} value={String(m.id)}>{m.value}</option>)}
          </select>
        </div>
      </div>

      {/* Resumen periodo seleccionado */}
      {periodo && mes && (
        <div className="mb-3 px-3 py-2" style={{ backgroundColor: "#f0f4ff", borderRadius: 8, fontSize: 13, color: "#4a6cf7", fontWeight: 600 }}>
          <FontAwesomeIcon icon={faFileAlt} className="mr-2" />
          Cargando boletas para: <strong>{mesLabel} {periodo}</strong>
        </div>
      )}

      {/* Dropzone */}
      <div className="mb-3">
        <label style={{ fontSize: 13, fontWeight: 600, color: "#555", marginBottom: 6 }}>
          Archivos PDF
        </label>
        <DropZoneV2 getArchivos={setArchivos} setisValidNombre={setIsValidNombre} />
      </div>

      {/* Validación formato nombre */}
      {!isValidNombre && (
        <Alert variant="danger" style={{ fontSize: 13, borderRadius: 8 }}>
          <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />
          El formato del nombre no es correcto. Debe ser: <strong>DNI_EMPLEADO_EMPRESA.pdf</strong>
        </Alert>
      )}

      {/* Lista de archivos seleccionados */}
      {archivos.length > 0 && (
        <div className="mb-3">
          <div style={{ fontSize: 13, fontWeight: 700, color: "#555", marginBottom: 8 }}>
            <FontAwesomeIcon icon={faCheckCircle} className="mr-1 text-success" />
            {archivos.length} archivo(s) seleccionado(s)
          </div>
          <div style={{ maxHeight: 180, overflowY: "auto", border: "1px solid #e9ecef", borderRadius: 8 }}>
            {archivos.map((a, i) => (
              <div key={i} className="d-flex align-items-center justify-content-between px-3 py-2"
                style={{ borderBottom: "1px solid #f5f5f5", fontSize: 13 }}>
                <div className="d-flex align-items-center" style={{ gap: 8, flex: 1, minWidth: 0 }}>
                  <FontAwesomeIcon icon={faFileAlt} style={{ color: "#dc3545", flexShrink: 0 }} />
                  <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "#444" }}>
                    {a.name}
                  </span>
                </div>
                <button
                  type="button"
                  onClick={() => removeArchivo(a.name)}
                  style={{ background: "none", border: "none", color: "#aaa", cursor: "pointer", padding: "0 4px", flexShrink: 0 }}
                >
                  <FontAwesomeIcon icon={faTimesCircle} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Botón guardar */}
      <div className="d-flex justify-content-end mt-3">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={archivos.length === 0 || !isValidNombre}
          style={{ borderRadius: 8, fontWeight: 600, minWidth: 140 }}
        >
          <FontAwesomeIcon icon={faUpload} className="mr-2" />Cargar boletas
        </button>
      </div>
    </form>
  );
};

export default FormularioSubidaBoletas;
